'use strict';

var Util = require("../layouts/util.js");
var React = require("react");
var Gatsby = require("../gatsby.js");
var ReasonReact = require("reason-react/src/ReasonReact.js");

var component = ReasonReact.statelessComponent("ViennaGuideSection");

function make(title, content, $staropt$star, _) {
  var backTo = $staropt$star ? $staropt$star[0] : "attendees#exploring-vienna";
  return /* record */[
          /* debugName */component[/* debugName */0],
          /* reactClassInternal */component[/* reactClassInternal */1],
          /* handedOffState */component[/* handedOffState */2],
          /* willReceiveProps */component[/* willReceiveProps */3],
          /* didMount */component[/* didMount */4],
          /* didUpdate */component[/* didUpdate */5],
          /* willUnmount */component[/* willUnmount */6],
          /* willUpdate */component[/* willUpdate */7],
          /* shouldUpdate */component[/* shouldUpdate */8],
          /* render */(function () {
              return React.createElement("section", undefined, React.createElement("h1", {
                              id: "top"
                            }, Util.s(title)), React.createElement("p", {
                              className: "leadText"
                            }, ReasonReact.element(/* None */0, /* None */0, Gatsby.Link[/* make */0](backTo, /* None */0, /* None */0, /* None */0, /* array */[Util.s("Go back")])), Util.s(" to the overview")), React.createElement("main", undefined, Util.md(content)));
            }),
          /* initialState */component[/* initialState */10],
          /* retainedProps */component[/* retainedProps */11],
          /* reducer */component[/* reducer */12],
          /* subscriptions */component[/* subscriptions */13],
          /* jsElementWrapped */component[/* jsElementWrapped */14]
        ];
}

var Link = 0;

exports.Link = Link;
exports.component = component;
exports.make = make;
/* component Not a pure module */



// WEBPACK FOOTER //
// ./src/components/viennaGuideSection.js